interface Folder {
  id: string
  name: string
  child: Folder[]
}

export function flattenFolders(
  folders: Folder[],
  path: string[] = [],
  depth = 1
) {
  const result = []

  folders.forEach(folder => {
    result.push({ id: folder.id, path: path.concat(folder.name) })

    result.push(
      ...flattenFolders(folder.child, path.concat(folder.name), depth + 1)
    )
  })

  return result
}

export async function getEncodedImage(imageUrl: string) {
  try {
    const response = await fetch(imageUrl, {
      credentials: 'include'
    })
    const blob = await response.blob()
    const reader = new FileReader()

    return new Promise((resolve, reject) => {
      reader.onloadend = () => {
        const rawCharacters = (reader.result as string).split(',')[1]

        resolve(rawCharacters)
      }

      reader.onerror = () => {
        reject(new Error('Failed to read image'))
      }

      reader.readAsDataURL(blob)
    })
  } catch (error) {
    console.error('Error fetching image:', error)
  }

  return null
}
